import { getIn, useFormikContext } from "formik";
import { forwardRef } from "react";
import { GetRef } from "tamagui";

import { Select, SelectProps } from "./Select";

export interface FormikSelectProps
  extends Omit<
    SelectProps,
    "value" | "error" | "helperText" | "onValueChange"
  > {
  fieldName: string;
  validateOnClose?: boolean;
  validateOnChange?: boolean;
  onClose?: () => void;
}

export const FormikSelect = forwardRef<
  GetRef<typeof Select>,
  FormikSelectProps
>(function FormikSelect(
  { fieldName, validateOnClose, validateOnChange, onClose, ...rest },
  ref,
) {
  const {
    values,
    errors,
    touched,
    handleChange,
    setFieldTouched,
    validateField,
  } = useFormikContext<Record<string, string | undefined>>();

  const value = getIn(values, fieldName);
  const error = getIn(errors, fieldName);
  const isTouched = getIn(touched, fieldName);

  return (
    <Select
      ref={ref}
      value={value}
      error={isTouched && !!error}
      helperText={isTouched && error ? error : undefined}
      onClose={() => {
        setFieldTouched(fieldName);
        if (onClose) onClose();
        if (validateOnClose) validateField(fieldName);
      }}
      onValueChange={(value) => {
        handleChange(fieldName)(String(value));
        if (validateOnChange) validateField(fieldName);
      }}
      {...rest}
    />
  );
});
